import { Container, Nav, Navbar, NavDropdown, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

function MyNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorage.getItem("userRole");
  const userEmail = localStorage.getItem("userEmail");
  const [scrolled, setScrolled] = useState(false);

  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    if (isHomePage) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [isHomePage]);

  const handleLogout = () => {
    localStorage.removeItem("userRole");
    localStorage.removeItem("userEmail");
    navigate("/login");
  };

  const navbarStyle = isHomePage
    ? {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: scrolled
          ? "rgba(255, 255, 255, 0.98)"
          : "rgba(255, 255, 255, 0.1)",
        backdropFilter: scrolled ? "blur(10px)" : "none",
        transition: "all 0.3s ease",
        boxShadow: scrolled ? "0 2px 20px rgba(0,0,0,0.1)" : "none",
      }
    : {};

  const linkStyle =
    isHomePage && !scrolled
      ? {
          color: "#fff !important",
        }
      : {};

  return (
    <Navbar
      expand="lg"
      className={!isHomePage || scrolled ? "shadow-sm" : ""}
      style={navbarStyle}
      variant={isHomePage && !scrolled ? "dark" : "light"}
    >
      <Container>
        <Navbar.Brand
          as={Link}
          to="/"
          className="fw-bold"
          style={{ color: isHomePage && !scrolled ? "#fff" : "#667eea" }}
        >
          <i className="bi bi-cup-hot-fill me-2"></i>
          UC Study Coffee
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          style={{
            borderColor: isHomePage && !scrolled ? "rgba(255,255,255,0.5)" : "",
          }}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" style={linkStyle}>
              Trang chủ
            </Nav.Link>
            <Nav.Link as={Link} to="/menu" style={linkStyle}>
              Menu & Order
            </Nav.Link>
            {userRole && (
              <Nav.Link as={Link} to="/booking" style={linkStyle}>
                Đặt bàn
              </Nav.Link>
            )}
          </Nav>

          <Nav>
            {userRole ? (
              <NavDropdown
                title={
                  <span>
                    <i className="bi bi-user me-1"></i>
                    {userEmail || "Tài khoản"}
                  </span>
                }
                id="basic-nav-dropdown"
                align="end"
              >
                <NavDropdown.Item disabled className="small text-muted">
                  Vai trò:{" "}
                  <strong className="text-primary text-uppercase">
                    {userRole}
                  </strong>
                </NavDropdown.Item>
                <NavDropdown.Divider />

                {userRole === "admin" && (
                  <NavDropdown.Item as={Link} to="/admin">
                    <i className="bi bi-speedometer2 me-2"></i>Admin Dashboard
                  </NavDropdown.Item>
                )}

                {userRole === "staff" && (
                  <NavDropdown.Item as={Link} to="/staff">
                    <i className="bi bi-briefcase me-2"></i>Staff Portal
                  </NavDropdown.Item>
                )}

                {(userRole === "customer" || userRole === "admin") && (
                  <>
                    <NavDropdown.Item as={Link} to="/profile">
                      <i className="bi bi-user me-2"></i>Hồ sơ
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/member-card">
                      <i className="bi bi-credit-card me-2"></i>Thẻ hội viên
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/history">
                      <i className="bi bi-clock-history me-2"></i>Lịch sử
                    </NavDropdown.Item>
                  </>
                )}

                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={handleLogout}
                  className="text-danger"
                >
                  <i className="bi bi-log-out me-2"></i>Đăng xuất
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Button
                as={Link}
                to="/login"
                variant={isHomePage && !scrolled ? "outline-light" : "primary"}
                size="sm"
                className="rounded-pill px-4"
              >
                <i className="bi bi-log-in me-2"></i>
                Đăng nhập
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default MyNavbar;
